/* PlayAlaab scroll-reveal — fades/slides elements in as they enter view.
   Only runs when <html> has .pa-anim (added early, skipped for reduced motion). */
(function () {
  if (!document.documentElement.classList.contains('pa-anim')) return;
  document.documentElement.classList.add('pa-reveal-ready');

  function init() {
    var els = document.querySelectorAll('.pa-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pa-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pa-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
